import {NextState} from '@react-hookz/web/cjs/util/resolveHookState';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import Button from 'Components/Tailwind/Button';
import React from 'react';
import {StyleGuide} from './hooks/useStyleguideData';

interface Props {
    styleGuide: StyleGuide | undefined;
    setStyleGuide: (val: NextState<StyleGuide, StyleGuide | undefined>) => void;
    previewText: string;
    showPreviewText: boolean;
    selectedClass: string;
    setSelectedClass: React.Dispatch<React.SetStateAction<string>>;
}

export const StyleMap: React.FC<Props> = ({
    styleGuide,
    setStyleGuide,
    previewText,
    showPreviewText,
    selectedClass,
    setSelectedClass,
}) => {
    const cssClasses = styleGuide?.cssClasses;

    if (!cssClasses) {
        return null;
    }

    return (
        <div className="flex w-full flex-col gap-8 px-8 text-neutral-700">
            {cssClasses &&
                Object.keys(cssClasses).map((key) => {
                    const cssObject = cssClasses[key];
                    const isSelected = selectedClass === key;
                    const webflowClassName = styleGuide.cssClassMeta?.[key]?.webflow.name;
                    return (
                        <div key={key} className="flex w-full flex-row flex-nowrap gap-24">
                            <Button
                                outlined
                                className="mt-10 basis-24 text-neutral-700"
                                success={isSelected}
                                onClick={() => setSelectedClass(key)}
                            >
                                {isSelected ? 'Selected' : 'Edit'}
                            </Button>
                            <div
                                key={key}
                                className={classNames(
                                    'flex w-full flex-col gap-2 rounded-md border px-12 py-8 text-neutral-700',
                                    !isSelected && 'border-transparent',
                                    isSelected && 'border-sky-500'
                                )}
                            >
                                <h1 className="mt-2 flex items-center gap-4 text-3xl font-extrabold uppercase after:h-px after:flex-1 after:bg-neutral-600 after:content-['']">
                                    {webflowClassName || key}
                                </h1>
                                {Object.keys(cssObject).map((cssKey) => {
                                    const cssValue = cssClasses[key][cssKey];
                                    return (
                                        <div key={cssKey} className="flex flex-row items-center gap-2 px-12 py-1">
                                            <p className="text-md font-semibold text-neutral-700">{cssKey}</p>
                                            <p className="text-sm font-normal text-neutral-600">{cssValue}</p>
                                        </div>
                                    );
                                })}
                                {showPreviewText && !isEmpty(cssObject) && (
                                    <div className="mb-8 mt-8 flex w-full items-center justify-start">
                                        <span
                                            style={{
                                                ...cssObject,
                                                fontFamily: `'${cssObject.fontFamily}'`,
                                            }}
                                        >
                                            {previewText}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};
